import React from 'react'
import { observable } from 'mobx'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import { BaseManipStateFn, BaseTableState } from './base'

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    prepareNew () {
      // set default value if name is empty
      if (!this.record.has('name')) {
        this.record.set('name', [])
        this.record.get('name').push({ lang: 'en', value: '' })
      }
    }

    onSaved (saved) {
      super.onSaved(saved)
      store.markDirty(linkConst.LINK_PERSONS)
    }

    beforeSave (entity) {
      entity.name.forEach(n => n.value = n.value ? n.value.trim() : null)
      super.beforeSave(entity)
    }

    flagEditDone () {
      if (store.router && store.router.queryParams) {
        delete store.router.queryParams._tablang
        delete store.router.queryParams._autoscroll
      }
      super.flagEditDone()
    }

    load (entity, id) {
      this.createtitle = store.__(linkConst.LINK_PERSONS_TITLE) +
        defaultConst.TITLE_DIVIDER + store.__(defaultConst.TITLE_EDIT)
      store.requester.call(`/${entity}/${id}`)
        .then(found => {
          store.record = observable(found.data)
          this.onLoaded(store.record)
        })
    }

    onLoaded (entity) {
      const name = entity && entity.name && entity.name[0]
      if (name && name.value) {
        this.edittitle = (
          <span>
            {store.__(linkConst.LINK_PERSONS_TITLE).concat(defaultConst.TITLE_DIVIDER)}
            <span className='text-primary text-strong'> {name.value} </span>
            {defaultConst.TITLE_DIVIDER}
            {store.__(defaultConst.TITLE_EDIT)}
          </span>)
      }
      super.onLoaded(entity)
    }

    handleRemove (row) {
      store.removeArrayRow(
        'name', row, (store.modalEntity && store.record.name)
      )
    }

    handleAdd (lang) {
      store.addArrayRow(
        'name', { lang, value: '' }, (store.modalEntity && store.record.name)
      )
    }

    handleChange (lang, value) {
      store.changeAttrArrayValue(
        'name', { lang }, value, (store.modalEntity && store.record.name)
      )
    }

    copyLang (entity, tablang) {
      const def = entity.get('name').find(i => i.lang === defaultConst.DEFAULT_LANG)
      const update = entity.get('name').find(i => i.lang === tablang)

      if (update && update.lang) {
        update.value = def.value
        update.udated = Date.now()
      } else {
        entity.get('name').push({ lang: tablang, value: def.value })
      }
      store.addMessage('Copied', 'info')
    }

    requiredOptions = [
      'FilmCargoLanguages'
    ]

    createtitle = store.__(linkConst.LINK_PERSONS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_PERSONS_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)
    validators = {
      _global: (vals, errors) => {
        if (!vals.get('name')[0].value || vals.get('name')[0].value.length === 0) {
          return [store.__('At least english title is mandatory')]
        }
      }
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id', 'name', 'birth_year'
    ]

    headertitles = [
      store.__('ID'), store.__('name'), store.__('Birth year')
    ]

    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_PERSONS]
    title = store.__(linkConst.LINK_PERSONS_TITLE)
  }

  return { ManipState, TableState }
}
